import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Job History")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Search by Registration Number ", -1)
const _hoisted_11 = { class: "col-md-2 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "p-3 mt-3" }, "Employment Information", -1)
const _hoisted_15 = { id: "trainee_profile" }
const _hoisted_16 = { class: "profile-info pt-1 pb-1" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "thumbnail text-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bold d-block pt-1" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user fa-10x" })
    ])
  ])
], -1)
const _hoisted_19 = { class: "col-sm-9" }
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = { class: "table" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Employment Type")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Company Name")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Address")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Country")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Designation")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"150px"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Organization Type")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"230px"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Monthly Income/Salary(BDT)")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Job Duration ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registration_number) = $event)),
                    placeholder: "Search"
                  }, null, 512), [
                    [_vModelText, _ctx.registration_number]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getHistory && _ctx.getHistory(...args))),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_12
                ])
              ])
            ]),
            (_ctx.showDescription)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EmploymentList, (info, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "pt-9 card mt-2",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("table", _hoisted_21, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_22,
                                      _createElementVNode("td", null, [
                                        _createTextVNode(": "),
                                        (info.employment_type == 1)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode("Self Employment")
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (info.employment_type == 2)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode("Wages Employment")
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (info.employment_type == 3)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              _createTextVNode("Upskill Employment")
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _hoisted_23,
                                      _createElementVNode("td", null, ": " + _toDisplayString(info.organization_name), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_24,
                                      _createElementVNode("td", null, ": " + _toDisplayString(info.organization_address), 1),
                                      _hoisted_25,
                                      _createElementVNode("td", null, ": " + _toDisplayString(info?.country_info?.full_name), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_26,
                                      _createElementVNode("td", null, ": " + _toDisplayString(info.designation), 1),
                                      _hoisted_27,
                                      _createElementVNode("td", null, ": " + _toDisplayString(info.organization_type), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_28,
                                      _createElementVNode("td", null, ": " + _toDisplayString(info.salary), 1),
                                      _hoisted_29,
                                      _createElementVNode("td", null, ": " + _toDisplayString(info?.joining_date) + " To " + _toDisplayString((info.release_date)? info.release_date : "Present"), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}